








import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ProgressBar extends Vue {
    @Prop({type: Number, default: 100}) readonly percentage!: number

    get style(): object {
        return {
            width: this.percentage + '%',
        }
    }
}

